module.exports = __webpack_public_path__ + "img/solucoesTecnologiaOPENCARD_SMALL.c6edbf7c.jpg";